import React from "react";
import 'react-phone-number-input/style.css';
import {ActivityHeaderDisplay} from "./ActivityHeaderDisplay";
import {ActivityDirectionDisplay} from "./ActivityDirectionDisplay";
import {Activity} from "../../types/Activity";
import {ActivityBrokerAssignment} from "../../types/ActivityBrokerAssignment";
import {DateUtility} from "../common/DateUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";

interface ActivityDetailProps {
    activity: Activity;
    index: number;
}

export let ActivityDetail = function (props: ActivityDetailProps) {
    let activity = props.activity;
    let activityBrokerAssignmentsDisplay: any = [];
    for (let i = 0; i < activity.activity_broker_assignments.length; i++) {
        let activityBrokerAssignment = activity.activity_broker_assignments[i];
        activityBrokerAssignmentsDisplay.push(
            <ActivityBrokerAssignmentDetail
                index={i}
                activityBrokerAssignment={activityBrokerAssignment}
                activity={activity}
            />
        )
    }

    if (activity.activity_broker_assignments.length === 0) {
        activityBrokerAssignmentsDisplay = (
            <div className="empty-broker-assignments-message">
                No broker assignments found.
            </div>
        )
    }

    return (
        <div className="activity-detail">
            <ActivityHeaderDisplay
                activity={activity}
                displayIndex={props.index + 1}
                purchaseOrderNumber={activity.purchase_order_number}
            />
            {activityBrokerAssignmentsDisplay}

        </div>
    )
}

interface ActivityBrokerAssignmentDetailProps {
    activity: Activity;
    activityBrokerAssignment: ActivityBrokerAssignment;
    index: number;
}

let ActivityBrokerAssignmentDetail = function (props: ActivityBrokerAssignmentDetailProps) {
    let activity = props.activity;
    let activityBrokerAssignment = props.activityBrokerAssignment;
    let material = activityBrokerAssignment.assigned_activity_material;
    let materialDisplayText = material ? `${activityBrokerAssignment.assigned_material_amount} ${material.measurement_unit}s ${material.name}` : "";
    let roundRobinIcon = undefined;
    if (activityBrokerAssignment.is_round_robin) {
        roundRobinIcon = <img
            src="/static/images/round-robin-light-gray-on-textcolor.svg"
            className="activity-broker-assignment-detail-header-round-robin-icon"
        />
    }
    return (
        <div className="activity-broker-assignment-detail">
            <div className="activity-broker-assignment-detail-header">
                <div className="activity-broker-assignment-detail-header-content">
                    <div className="activity-broker-detail-name">
                        <div className="activity-broker-detail-name-text">
                            {activityBrokerAssignment.broker?.name}
                        </div>
                        {roundRobinIcon}
                    </div>
                    <div className="activity-broker-detail-truck-count">
                        <div className="activity-broker-detail-truck-count-text">
                            {
                                activityBrokerAssignment.pit_haul
                                    ? '+'
                                    : (activityBrokerAssignment.truck_count != null ? String('' + activityBrokerAssignment.truck_count).padStart(2, '0') : '')
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="activity-broker-assignment-detail-body">
                <div className="activity-broker-assignment-detail-body-content">
                    <div className="activity-broker-body-direction">
                        <ActivityDirectionDisplay directionName={activity.activity_direction.name}/>
                    </div>
                    <div className="activity-broker-body-material">
                        {materialDisplayText}
                    </div>
                    <div className="activity-broker-body-shapes">
                        <div className="activity-broker-body-line"/>
                        <div className="activity-broker-body-circle"/>
                    </div>
                    <div className="activity-broker-body-time">
                        {DateUtility.dbDateToBrokerAssignmentDisplayTime(activityBrokerAssignment.start_time)}
                    </div>
                </div>
            </div>
            <ConditionalRenderer if={activityBrokerAssignment.notes} renderer={() => (
                <ActivityBrokerAssignmentDetailNotes
                    label="ACTIVITY NOTES"
                    body={activityBrokerAssignment.notes}
                    wrapperClass="activity-broker-assignment-detail-notes"
                />
            )}/>
            <ConditionalRenderer if={activityBrokerAssignment.broker_notes} renderer={() => (
                <ActivityBrokerAssignmentDetailNotes
                    label="BROKER NOTES"
                    body={activityBrokerAssignment.broker_notes}
                    wrapperClass="activity-broker-assignment-detail-broker-notes"
                />
            )}/>
        </div>
    )
}

let ActivityBrokerAssignmentDetailNotes = function (props: any) {
    return (
        <div className={`activity-broker-assignment-notes ${props.wrapperClass}`}>
            <div className="activity-broker-assignment-notes-content">
                <div className="activity-broker-assignment-notes-label">
                    {props.label}
                </div>
                <div className="activity-broker-assignment-notes-body">
                    {props.body}
                </div>
            </div>
        </div>
    )
}
